// İSG uzmanı portalı — Panel (Expert Dashboard) TanStack Query anahtarları (api-contract §34,
// tenant-scoped). `permitsKeys.ts`/`contractorsKeys.ts` ile AYNI desen.
//
// **`summary(siteUuid)` — S35 (owner review B3-1) saha süzgecini TAŞIR** (§35.2). Eskiden
// parametresiz idi (`GET /dashboard/summary` hiçbir filtre almıyordu, saha seçici YALNIZ
// "Bugünkü girişler" panelini süzüyordu — `DashboardPage.tsx`'in eski dosya başlığı notu).
// S35 sonrası uç `siteUuid` alır; anahtar onu İÇERMEK ZORUNDADIR, aksi hâlde saha değişimi bir
// önceki sahanın (ya da "tüm sahalar"ın) KPI'larını önbellekten sunardı. `actionItems()` liste
// parametrelerini (kind/siteUuid/page/pageSize) İÇERİR — süzgeç/sayfa/saha değişince yeniden çeker.

import type { ExpertActionItemListParams } from '@isgportal/shared';

export const dashboardKeys = {
  /** Tüm panel sorgularının kök öneki — invalidasyon için. */
  all: () => ['dashboard'] as const,
  /** `GET /dashboard/summary` — `siteUuid` dâhil (§35.2; `null` = firma geneli). */
  summary: (siteUuid: string | null = null) => ['dashboard', 'summary', siteUuid] as const,
  /** Tüm "Aksiyon gerekli" liste sorgularının öneki (kind/saha/sayfa varyantlarını kapsar). */
  actionItemsList: () => ['dashboard', 'action-items'] as const,
  /** Sayfalı + `kind`/`siteUuid` süzgeçli "Aksiyon gerekli" listesi — parametreli. */
  actionItems: (params: ExpertActionItemListParams) =>
    ['dashboard', 'action-items', params] as const,
} as const;
